import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';

function Landing() {
  const { t } = useTranslation();
  useEffect(() => {
    const head = document.querySelector('head');
    const script = document.createElement('script');
    const script2 = document.createElement('script');

    script.setAttribute('src', '/js/cookie-consent.js');
    script.charset = 'utf-8';
    script2.innerHTML = 'cookieconsent.run({"notice_banner_type":"simple","consent_type":"express","palette":"light","language":"en","page_load_consent_levels":["strictly-necessary"],"notice_banner_reject_button_hide":false,"preferences_center_close_button_hide":false,"page_refresh_confirmation_buttons":false,"website_name":"Dineout"});';
    head.appendChild(script);

    script.onload = () => {
      head.appendChild(script2);
    };

    return () => {
      head.removeChild(script);
      head.removeChild(script2);
    };
  }, []);
  return (
    <Routes>
      <Route
        path="/"
        exact
        element={(
          <div className="widget-landing">

            <LanguageSwitcher locales={['en', 'bg', 'it', 'hr', 'pl']} />
            <div className="main-block">

              <div className="main-block-header">
                <h2>
                  <strong>{t('widgetLanding:importantNotice')}</strong>
                </h2>

              </div>

              <div className="main-block-content">
                <h1>{t('widgetLanding:title')}</h1>

                <p className="section-sub-title">
                  {t('widgetLanding:subtitle')}
                </p>

                <div className="booking-confirmed-section">
                  <h2 className="section-title">
                    <strong>{t('widgetLanding:whatThisMeans')}</strong>
                  </h2>

                  <p>
                    {t('widgetLanding:oldWidgetText')}
                    {' '}
                    <a
                      href="https://book.restomatix.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      book.restomatix.com
                    </a>
                    ).
                  </p>

                  <p>{t('widgetLanding:bookingPagesText')}</p>
                </div>

                <div className="booking-confirmed-section">
                  <h2 className="section-title">
                    <strong>{t('widgetLanding:nextSteps')}</strong>
                  </h2>

                  <p>
                    {t('widgetLanding:youCan')}
                    {' '}
                    <a
                      href="https://app.restomatix.com/set-up/restaurant-profile"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t('widgetLanding:findItInRestaurantProfile')}
                    </a>
                    {' '}
                    {t('widgetLanding:or')}
                    {' '}
                    <a
                      href="https://app.restomatix.com/account/contact-dineout"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t('widgetLanding:contactAccountManager')}
                    </a>
                    {' '}
                    {t('widgetLanding:nextStepsText')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      />
    </Routes>
  );
}

export default Landing;
